import { styled } from '@mui/system';
import { ToggleButtonGroup, ToggleButton } from '@mui/material';

export const ToggleButtonGroupStyled = styled(ToggleButtonGroup)(
  ({ theme }) => ({
    background: theme?.palette?.buttonFontColor,
    borderRadius: '0.9375rem',
    width: '100%',
    padding: '0.625rem 0 0.625rem 0.625rem',
    margin: '7.5px 0',
    '& .MuiButtonBase-root.MuiToggleButtonGroup-grouped.Mui-selected': {
      border: `0.125rem solid ${theme?.palette?.lightBlue} !important`,
      backgroundColor: theme?.palette?.buttonFontColor
    }
  })
);

export const ToggleButtonStyled = styled(ToggleButton)(({ theme }) => ({
  marginRight: '0.625rem',
  padding: '0.9375rem 1.25rem',
  width: '50%',
  borderRadius: '0.3125rem !important',
  fontSize: '1rem',
  fontWeight: 450,
  color: theme?.palette?.primaryDark,
  border: `0.0625rem solid ${theme?.palette?.dividerBorder} !important`
}));
